import { Meal } from "../mealPlan.types";

export const getDisplayedMonths = (daysInWeek: Date[]) => {
  const startMonth = daysInWeek[0].toLocaleString('default', { month: 'long' });
  const endMonth = daysInWeek[daysInWeek.length - 1].toLocaleString('default', { month: 'long' });

  if (startMonth !== endMonth) {
    return `${startMonth} - ${endMonth}`;
  }
  return `${startMonth}`;
};


export const getDaysInWeek = (date: Date) => {
  const startOfWeek = new Date(date);
  startOfWeek.setDate(date.getDate() - date.getDay());

  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    days.push(day);
  }
  return days;
};

export const isCurrentDate = (day: Date, currentDay: Date) => {
  return currentDay.getDate() === day.getDate() &&
    currentDay.getMonth() === day.getMonth() &&
    currentDay.getFullYear() === day.getFullYear();
};

export const isPastDate = (date: Date, today: Date): boolean => {
  const todayCopy = new Date(today);
  todayCopy.setHours(0, 0, 0, 0); // Set to start of today (00:00:00)

  return date < todayCopy;
};

export const isCurrentOrPastDate = (date: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dateCopy = new Date(date);
  dateCopy.setHours(0, 0, 0, 0); 

  return dateCopy <= today;
};



export const areSameDay = (dbDate: string, currentDate: Date) => {
  const dbUTCDate = new Date(dbDate + "Z");

  const dbYear = dbUTCDate.getFullYear();
  const dbMonth = dbUTCDate.getMonth();
  const dbDay = dbUTCDate.getDate();

  const localYear = currentDate.getFullYear();
  const localMonth = currentDate.getMonth();
  const localDay = currentDate.getDate();

  return (
    localYear === dbYear &&
    localMonth === dbMonth &&
    localDay === dbDay
  );
};


export const isDateInPast = (dbDate: string, currentDate: Date) => {
  const dbUTCDate = new Date(dbDate + "Z"); 

  return dbUTCDate.getTime() < currentDate.getTime()
};



//export const getDaysInMonth = (date: Date) => {
//   const year = date.getFullYear();
//   const month = date.getMonth();
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const firstDayOfMonth = new Date(year, month, 1).getDay();

//   const days = [];
//   for (let i = 0; i < firstDayOfMonth; i++) {
//     days.push(null);
//   }
//   for (let i = 1; i <= daysInMonth; i++) {
//     days.push(new Date(year, month, i));
//   }
//   return days;
// };

export const dateHasMeals = (currentDate: Date, meals?: Meal[]): boolean => {
  if (!Array.isArray(meals) || meals.length === 0) {
    return false;
  }

  return meals.some(meal => {
    return areSameDay(meal.scheduled_date_time, currentDate);
  });
};

